import React from 'react'
import { useQuery } from 'urql'
import { REPOSITORY_NAME } from '../../config'
import Loading from '../Loading'
import './index.css'
import Error from '../Error'

interface IProps {
  number: Number
  onClick: () => void
}

const Post: React.FC<IProps> = ({ number, onClick }) => {
  const [result] = useQuery({
    query: `{
      viewer {
        repository(name: "${REPOSITORY_NAME}") {
          issue(number: ${number}) {
            title
            publishedAt
            bodyHTML
          }
        }
      }
    }`
  })
  const { fetching, data, error } = result

  if (fetching) {
    return <Loading />
  }

  if (error) {
    return <Error msg={error.message} />
  }

  const {
    viewer: {
      repository: {
        issue: { title, publishedAt, bodyHTML }
      }
    }
  } = data

  return (
    <div className="post" onClick={onClick}>
      <h1>{title}</h1>
      <i className="post-time">{new Date(publishedAt).toDateString()}</i>
      <article
        className="markdown-body"
        dangerouslySetInnerHTML={{ __html: bodyHTML + bodyHTML + bodyHTML }}
      ></article>
    </div>
  )
}

export default Post
